/**
 * @alpha
 */
class PubHubError extends Error {
    name = "pubhub-generic-error";
    cause;
    customAttributes;
    constructor(message, { cause } = {}, customAttributes) {
        super(message);
        this.cause = cause instanceof Error ? cause : new Error(String(cause));
        this.customAttributes = customAttributes;
    }
}
/**
 * @alpha
 */
class HostTimeoutError extends PubHubError {
    name = "pubhub-sdk-timeout";
}
/**
 * @alpha
 */
class PcsTimeoutError extends PubHubError {
    name = "pubhub-channel-data-timeout";
}
/**
 * @alpha
 */
class PcsChannelFetchError extends PubHubError {
    name = "pubhub-channel-data-fetch-error";
}
/**
 * @alpha
 */
class PcsTelemetryError extends PubHubError {
    name = "pubhub-telemetry-error";
}

export { HostTimeoutError, PcsChannelFetchError, PcsTelemetryError, PcsTimeoutError, PubHubError };
//# sourceMappingURL=errors.mjs.map
